import { Module } from '../../ts/Module';
import { AnalyticsExtensionsSettingsCtrl } from '../controllers/SiteSettingsForAnalyticsExtensionsCtrl';

Module.instance().directive('tbAnalyticsExtensionsSettingsForm',
  () => {
    return {
      restrict: 'E',
      require: '^?tbSettingsCoordinator',
      template: '<tb:analytics-extensions-settings props="props"/>',
      controller: AnalyticsExtensionsSettingsCtrl
    };
  }
);
